module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/see-invoices/see-invoices.component.scss
// module id = ./src/app/pages/see-invoices/see-invoices.component.scss
// module chunks = main